export class ScoreBoardRes {
  constructor(json, matchCompletedData) {
    this.live = new Live(json?.live);
    this.scoreBoard = new ScoreBoard(json?.scoreBoard);

    if (matchCompletedData?.matchCompleted) {
      this.updateDataOnMatchCompleted(matchCompletedData);
    }
  }

  updateDataOnMatchCompleted(matchCompletedData) {
    this.live.match.overview.isCompleted = matchCompletedData?.matchCompleted;
    this.live.match.overview.isLive = false;
    this.live.match.overview.overview =
      matchCompletedData?.matchResult?.overview;
  }
}

export class UpdatedScoreBoardRes {
  constructor(json, updates) {
    this.oldScoreBoard = new ScoreBoardRes(json);
    this.scoreBoardUpdates = new ScoreBoardUpdates(updates);
    this.updatedScoreBoard = new ScoreBoardRes(json);

    this.updateBatsmanScoreboard();
    this.updateNonStrikerScoreboard();
    this.updateBattingTeamScoreboard();
    this.updateBowlerScoreboard();
  }

  getBattingTeamKey() {
    const battingTeamId = this.scoreBoardUpdates?.battingTeamScoreboard?.teamId;
    const battingTeamKey = Object.keys(this.oldScoreBoard.scoreBoard).find(
      (key) => this.oldScoreBoard.scoreBoard[key].teamId === battingTeamId
    );
    return battingTeamKey;
  }

  getBowlingTeamKey() {
    const bowlingTeamId = this.scoreBoardUpdates?.bowlerScoreboard?.teamId;
    const bowlingTeamKey = Object.keys(this.oldScoreBoard.scoreBoard).find(
      (key) => this.oldScoreBoard.scoreBoard[key].teamId === bowlingTeamId
    );

    return bowlingTeamKey;
  }

  updateBatsmanScoreboard() {
    const batsmanId = this.scoreBoardUpdates?.batsmanScoreboard?.playerId;
    const battingTeamKey = this.getBattingTeamKey();

    const index = this.oldScoreBoard?.scoreBoard[
      battingTeamKey
    ]?.playerScores.findIndex((obj) => obj.playerId === batsmanId);

    if (index !== -1) {
      if (
        this.oldScoreBoard.scoreBoard.matchId === this.scoreBoardUpdates.matchId
      ) {
        this.oldScoreBoard.scoreBoard[battingTeamKey].playerScores[index] =
          this.scoreBoardUpdates?.batsmanScoreboard;

        this.oldScoreBoard.scoreBoard[battingTeamKey].playerScores[
          index
        ].isStriker = this.scoreBoardUpdates?.batsmanScoreboard?.isStriker;
      } else {
        const superOverIndex =
          this.oldScoreBoard.scoreBoard.superOverScoreboards.findIndex(
            (item) => item?.matchId === this.scoreBoardUpdates.matchId
          );

        if (superOverIndex !== -1) {
          this.oldScoreBoard.scoreBoard.superOverScoreboards[superOverIndex][
            battingTeamKey
          ].playerScores[index] = this.scoreBoardUpdates?.batsmanScoreboard;

          this.oldScoreBoard.scoreBoard.superOverScoreboards[superOverIndex][
            battingTeamKey
          ].playerScores[index].isStriker =
            this.scoreBoardUpdates?.batsmanScoreboard?.isStriker;
        }
      }

      this.oldScoreBoard.live.teamBatting.striker =
        this.scoreBoardUpdates?.batsmanScoreboard;
    } else {
    }

    this.updatedScoreBoard = new ScoreBoardRes(this.oldScoreBoard);
  }

  updateNonStrikerScoreboard() {
    const nonStrikerId = this.scoreBoardUpdates?.nonStrikerScoreboard?.playerId;
    const battingTeamKey = this.getBattingTeamKey();

    const index = this.oldScoreBoard?.scoreBoard[
      battingTeamKey
    ]?.playerScores.findIndex((obj) => obj.playerId === nonStrikerId);

    if (index !== -1) {
      if (
        this.oldScoreBoard.scoreBoard.matchId === this.scoreBoardUpdates.matchId
      ) {
        this.oldScoreBoard.scoreBoard[battingTeamKey].playerScores[index] =
          this.scoreBoardUpdates?.nonStrikerScoreboard;
      } else {
        const superOverIndex =
          this.oldScoreBoard.scoreBoard.superOverScoreboards.findIndex(
            (item) => item?.matchId === this.scoreBoardUpdates.matchId
          );

        if (superOverIndex !== -1) {
          this.oldScoreBoard.scoreBoard.superOverScoreboards[superOverIndex][
            battingTeamKey
          ].playerScores[index] = this.scoreBoardUpdates?.nonStrikerScoreboard;
        }
      }
      this.oldScoreBoard.live.teamBatting.nonStriker =
        this.scoreBoardUpdates?.nonStrikerScoreboard;
    } else {
    }

    this.updatedScoreBoard = new ScoreBoardRes(this.oldScoreBoard);
  }

  updateBattingTeamScoreboard() {
    const battingTeamKey = this.getBattingTeamKey();

    if (battingTeamKey) {
      if (
        this.oldScoreBoard.scoreBoard.matchId === this.scoreBoardUpdates.matchId
      ) {
        this.oldScoreBoard.scoreBoard[battingTeamKey].teamScoreboard =
          this.scoreBoardUpdates?.battingTeamScoreboard;
      } else {
        const superOverIndex =
          this.oldScoreBoard.scoreBoard.superOverScoreboards.findIndex(
            (item) => item?.matchId === this.scoreBoardUpdates.matchId
          );

        if (superOverIndex !== -1) {
          this.oldScoreBoard.scoreBoard.superOverScoreboards[superOverIndex][
            battingTeamKey
          ].teamScoreboard = this.scoreBoardUpdates?.battingTeamScoreboard;
        }
      }

      this.oldScoreBoard.live.teamBatting.teamScoreboard =
        this.scoreBoardUpdates?.battingTeamScoreboard;

      if (
        this.oldScoreBoard.live.teamBatting.teamId !==
        this.scoreBoardUpdates.battingTeamScoreboard.teamId
      ) {
        this.oldScoreBoard.live.teamBatting.teamId =
          this.scoreBoardUpdates.battingTeamScoreboard.teamId;
        this.oldScoreBoard.live.teamBatting.teamName =
          this.oldScoreBoard.live.teamBowling.teamName;
        this.oldScoreBoard.live.inning.innings_number = 2;
      }
    } else {
    }

    this.updatedScoreBoard = new ScoreBoardRes(this.oldScoreBoard);
  }

  updateBowlerScoreboard() {
    const bowlerId = this.scoreBoardUpdates?.bowlerScoreboard?.playerId;
    const bowlingTeamKey = this.getBowlingTeamKey();

    const index = this.oldScoreBoard?.scoreBoard[
      bowlingTeamKey
    ]?.playerScores?.findIndex((obj) => obj.playerId === bowlerId);

    if (index !== -1) {
      if (
        this.oldScoreBoard.scoreBoard.matchId === this.scoreBoardUpdates.matchId
      ) {
        this.oldScoreBoard.scoreBoard[bowlingTeamKey].playerScores[index] =
          this.scoreBoardUpdates?.bowlerScoreboard;
      } else {
        const superOverIndex =
          this.oldScoreBoard.scoreBoard.superOverScoreboards.findIndex(
            (item) => item?.matchId === this.scoreBoardUpdates.matchId
          );

        if (superOverIndex !== -1) {
          this.oldScoreBoard.scoreBoard.superOverScoreboards[superOverIndex][
            bowlingTeamKey
          ].playerScores[index] = this.scoreBoardUpdates?.bowlerScoreboard;
        }
      }
      this.oldScoreBoard.live.teamBowling.bowler =
        this.scoreBoardUpdates?.bowlerScoreboard;
    } else {
    }

    this.updatedScoreBoard = new ScoreBoardRes(this.oldScoreBoard);
  }
}

export class ScoreBoardUpdates {
  constructor(json) {
    this.matchId = json?.matchId;
    this.batsmanScoreboard = new Striker(json?.batsmanScoreboard);
    this.nonStrikerScoreboard = new Striker(json?.nonStrikerScoreboard);
    this.bowlerScoreboard = new Bowler(json?.bowlerScoreboard);
    this.battingTeamScoreboard = new TeamScoreboard(
      json?.battingTeamScoreboard
    );
  }
}

export class Live {
  constructor(json) {
    this.match = new Match(json?.match);
    this.inning = new Inning(json?.inning);
    this.teamBatting = new TeamBatting(json?.teamBatting);
    this.teamBowling = new TeamBowling(json?.teamBowling);
  }

  getProjectedScore() {
    return Math.floor(
      this.match?.overview?.totalOvers *
        parseFloat(this.teamBatting?.teamScoreboard?.getRunRate())
    );
  }

  getTossDetails() {
    const tossWinTeamId = this.match?.toss_win_team_id;
    const tossDecision = this?.match?.toss_decision;

    const tossWinTeamName =
      this.teamBatting?.teamId === tossWinTeamId
        ? this.teamBatting?.teamName
        : this.teamBowling?.teamName;

    return {
      tossWinTeamName,
      tossDecision,
    };
  }

  getChasingStr(scoreBoard) {
    const battingTeamKeyName =
      this.teamBatting?.teamId === scoreBoard?.teamA?.teamId
        ? "teamA"
        : "teamB";
    const teamBattingName = this.teamBatting?.teamName;
    const teamBowlingName = this.teamBowling?.teamName;
    const totalOvers = this.match?.overview?.totalOvers;
    const ballsRemaining =
      totalOvers * 6 - this.teamBatting?.teamScoreboard?.battingCurrentBall;
    const target = this.teamBowling?.teamScoreboard?.getTotalRuns() + 1;
    const runsRequied =
      target - this.teamBatting?.teamScoreboard?.getTotalRuns();
    const battingTeamWicketsRemaining =
      scoreBoard[battingTeamKeyName]?.playerScores.length -
      this.teamBatting?.teamScoreboard?.wicketsWhileBatting;

    if (runsRequied <= 0) {
      return `${teamBattingName} won the match by ${battingTeamWicketsRemaining} wickets`;
    }

    if (runsRequied > 0 && battingTeamWicketsRemaining <= 0) {
      return `${teamBowlingName} won the match by ${runsRequied - 1} runs`;
    }

    return `${teamBattingName} need ${runsRequied} runs in ${ballsRemaining} balls`;
  }
}

export class Match {
  constructor(json) {
    this.overview = new Overview(json?.overview);
    this.id = json?.id;
    this.is_live = json?.is_live;
    this.is_completed = json?.is_completed;
    this.tournament_id = json?.tournament_id;
    this.round_id = json?.round_id;
    this.toss_decision = json?.toss_decision;
    this.toss_win_team_id = json?.toss_win_team_id;
    this.created_by = json?.created_by;
    this.current_inning_id = json?.current_inning_id;
  }
}

export class Overview {
  constructor(json) {
    this.city = new City(json?.city);
    this._id = json?._id;
    this.teamA = json?.teamA;
    this.teamB = json?.teamB;
    this.matchName = json?.matchName;
    this.matchTime = json?.matchTime;
    this.matchType = json?.matchType;
    this.ground = json?.ground;
    this.ballType = json?.ballType;
    this.scorers = json?.scorers;
    this.umpires = json?.umpires;
    this.createdBy = json?.createdBy;
    this.totalOvers = json?.totalOvers;
    this.isLive = json?.isLive;
    this.isPaused = json?.isPaused;
    this.isCompleted = json?.isCompleted;
    this.createdAt = json?.createdAt;
    this.updatedAt = json?.updatedAt;
    this.totalRuns = json?.totalRuns;
    this.overview = json?.overview;
  }
}

export class City {
  constructor(json) {
    this._id = json?._id;
    this.stateId = json?.stateId;
    this.name = json?.name;
    this.stateName = json?.stateName;
  }
}

export class Inning {
  constructor(json) {
    this.id = json?.id;
    this.innings_number = json?.innings_number;
    this.striker_id = json?.striker_id;
    this.non_striker_id = json?.non_striker_id;
    this.bowler_id = json?.bowler_id;
    this.current_over_number = json?.current_over_number;
    this.current_ball_number = json?.current_ball_number;
    this.current_over = new CurrentOver(json?.current_over);
  }
}

export class CurrentOver {
  constructor(json) {
    this.id = json?.id;
    this.extras = json?.extras;
    this.runs_scored = json?.runs_scored;
    this.no_of_wickets = json?.no_of_wickets;
    this.runs_scored = json?.runs_scored;
    this.current_ball_number = json?.current_ball_number;
    this.ignored_ball_count = json?.ignored_ball_count;
    this.scores = json?.scores;
    // this.scores= new Score(json['scores'])
  }
}

export class Score {
  constructor(json) {
    this.id = json?.id;
    this.over_id = json?.over_id;
    this.bowler_id = json?.bowler_id;
    this.striker_id = json?.striker_id;
    this.non_striker_id = json?.non_striker_id;
    this.batsmanW = json?.batsmanW;
    this.fielderW = json?.fielderW;
    this.ball_number = json?.ball_number;
    this.can_count_ball = json?.can_count_ball;
    this.is_extra = json?.is_extra;
    this.runs_scored = json?.runs_scored;
    this.extra_runs = json?.extra_runs;
    this.is_six = json?.is_six;
    this.is_four = json?.is_four;
    this.is_wicket = json?.is_wicket;
    this.wicket_type_id = json?.wicket_type_id;
  }
}

export class TeamBatting {
  constructor(json) {
    this.teamId = json?.teamId;
    this.teamName = json?.teamName;
    this.teamLogo = json?.teamLogo;
    this.teamScoreboard = new TeamScoreboard(json?.teamScoreboard);
    this.striker = new Striker(json?.striker);
    this.nonStriker = new NonStriker(json?.nonStriker);
  }
}

export class TeamScoreboard {
  constructor(json) {
    this.battingExtraRunsMap = new BattingExtras(json?.battingExtraRunsMap);
    this.bowlingExtras = new BowlingExtras(json?.bowlingExtras);
    this._id = json?._id;
    this.matchId = json?.matchId;
    this.teamId = json?.teamId;
    this.battingCurrentBall = json?.battingCurrentBall;
    this.battingCurrentOver = json?.battingCurrentOver;
    this.battingExtraRuns = json?.battingExtraRuns;
    this.battingRuns = json?.battingRuns;
    this.bowlingCurrentBall = json?.bowlingCurrentBall;
    this.bowlingCurrentOver = json?.bowlingCurrentOver;
    this.bowlingExtraRuns = json?.bowlingExtraRuns;
    this.bowlingRuns = json?.bowlingRuns;
    this.createdAt = json?.createdAt;
    this.updatedAt = json?.updatedAt;
    this.wicketsWhileBatting = json?.wicketsWhileBatting;
    this.wicketsWhileBowling = json?.wicketsWhileBowling;
  }

  getTotalRuns() {
    return parseInt(this.battingRuns) + parseInt(this.battingExtraRuns);
  }

  getTotalBallsPlayed() {
    return parseFloat(this.battingCurrentOver + "." + this.battingCurrentBall);
  }

  getTotalOvers() {
    return (
      Math.floor(this.battingCurrentBall / 6) +
      "." +
      (this.battingCurrentBall % 6)
    );
  }

  getRunRate() {
    const totalOvers =
      Math.floor(this.battingCurrentBall / 6) +
      (this.battingCurrentBall % 6) / 6;

    // Check if totalOvers is not zero to avoid division by zero error
    if (totalOvers === 0) {
      return 0;
    } else {
      return parseFloat(this.getTotalRuns() / totalOvers).toFixed(2);
    }
  }

  getRunsRequired(target) {
    return target - this.getTotalRuns();
  }

  getBallsRemaining(totalOvers) {
    return totalOvers * 6 - this.battingCurrentBall;
  }

  getRequiredRunRate(totalOvers, target) {
    const ballsRemaining = totalOvers * 6 - this.battingCurrentBall;

    if (ballsRemaining === 0) return 0;

    const requiredRunRate =
      ((target - this.getTotalRuns()) / ballsRemaining) * 6;

    return parseFloat(requiredRunRate).toFixed(2);
  }
}

export class BattingExtras {
  constructor(json) {
    this.byeruns = json?.byeruns || 0;
    this.legbyes = json?.legbyes || 0;
    this.noball = json?.noball || 0;
    this.wide = json?.wide || 0;
  }
}

export class BowlingExtras {
  constructor(json) {
    this.byeruns = json?.byeruns;
    this.legbyes = json?.legbyes;
    this.noball = json?.noball;
    this.wide = json?.wide;
  }
}

export class Striker {
  constructor(json) {
    this.playerId = json?.playerId;
    this.playerName = json?.playerName;
    this._id = json?._id;
    this.matchId = json?.matchId;
    this.fielderIds = json?.fielderIds;
    this.ballsBowled = json?.ballsBowled;
    this.ballsPlayed = json?.ballsPlayed;
    this.battingExtraRuns = json?.battingExtraRuns;
    this.battingRuns = json?.battingRuns;
    this.bowlingExtraRuns = json?.bowlingExtraRuns;
    this.bowlingRuns = json?.bowlingRuns;
    this.createdAt = json?.createdAt;
    this.noOf4s = json?.noOf4s;
    this.noOf6s = json?.noOf6s;
    this.noOfOvers = json?.noOfOvers;
    this.noOfWickets = json?.noOfWickets;
    this.updatedAt = json?.updatedAt;
    this.isStriker = json?.isStriker;
    this.wicketBy = json?.wicketBy;
    this.wicketTypeId = json?.wicketTypeId;
    this.isOnPitch = json?.isOnPitch;
    this.bowlingExtras = new BowlingExtras2(json?.bowlingExtras);
    this.battingExtraRunsMap = new BattingExtras(json?.battingExtraRunsMap);
    this.battingOrder = json?.battingOrder;
    this.isOnPitchBowl = json?.isOnPitchBowl;
  }

  getSr() {
    const runs = parseInt(this.battingRuns);
    const balls = parseInt(this.ballsPlayed);

    if (isNaN(runs) || isNaN(balls) || balls === 0) {
      return 0;
    }

    return (runs / balls) * 100;
  }
}

export class BowlingExtras2 {
  constructor(json) {
    this.byeruns = json?.byeruns || 0;
    this.legbyes = json?.legbyes;
    this.noball = json?.noball;
    this.wide = json?.wide;
  }
}

export class NonStriker {
  constructor(json) {
    this.playerId = json?.playerId;
    this.playerName = json?.playerName;
    this._id = json?._id;
    this.matchId = json?.matchId;
    this.ballsBowled = json?.ballsBowled;
    this.ballsPlayed = json?.ballsPlayed;
    this.battingExtraRuns = json?.battingExtraRuns;
    this.battingRuns = json?.battingRuns;
    this.bowlingExtraRuns = json?.bowlingExtraRuns;
    this.bowlingRuns = json?.bowlingRuns;
    this.createdAt = json?.createdAt;
    this.noOf4s = json?.noOf4s;
    this.noOf6s = json?.noOf6s;
    this.noOfOvers = json?.noOfOvers;
    this.noOfWickets = json?.noOfWickets;
    this.updatedAt = json?.updatedAt;
    this.isStriker = json?.isStriker;
    this.bowlingExtras = new BowlingExtras2(json?.bowlingExtras);
    this.battingExtraRunsMap = new BattingExtras(json?.battingExtraRunsMap);
  }

  getSr() {
    const runs = parseInt(this.battingRuns);
    const balls = parseInt(this.ballsPlayed);

    if (isNaN(runs) || isNaN(balls) || balls === 0) {
      return 0;
    }

    return (runs / balls) * 100;
  }
}

export class TeamBowling {
  constructor(json) {
    this.teamId = json?.teamId;
    this.teamName = json?.teamName;
    this.teamLogo = json?.teamLogo;
    this.teamScoreboard = new TeamScoreboard(json?.teamScoreboard);
    this.bowler = new Bowler(json?.bowler);
  }
}

export class BowlingExtras3 {
  constructor(json) {
    this.byeruns = json?.byeruns;
    this.legbyes = json?.legbyes;
    this.noball = json?.noball;
    this.wide = json?.wide;
  }
}

export class Bowler {
  constructor(json) {
    this.playerId = json?.playerId;
    this.playerName = json?.playerName;
    this._id = json?._id;
    this.matchId = json?.matchId;
    this.ballsBowled = json?.ballsBowled;
    this.ballsPlayed = json?.ballsPlayed;
    this.battingExtraRuns = json?.battingExtraRuns;
    this.battingExtraRunsMap = new BattingExtras(json?.battingExtraRunsMap);
    this.battingRuns = json?.battingRuns;
    this.bowlingExtraRuns = json?.bowlingExtraRuns;
    this.bowlingExtras = new BowlingExtras4(json?.bowlingExtras);
    this.bowlingRuns = json?.bowlingRuns;
    this.createdAt = json?.createdAt;
    this.noOf4s = json?.noOf4s;
    this.noOf6s = json?.noOf6s;
    this.isOnPitch = json?.isOnPitch;
    this.noOfOvers = json?.noOfOvers;
    this.noOfWickets = json?.noOfWickets;
    this.updatedAt = json?.updatedAt;
    this.battingOrder = json?.battingOrder;
    this.bowlingOrder = json?.bowlingOrder;
    this.isOnPitchBowl = json?.isOnPitchBowl;
    this.maidenOvers = json?.maidenOvers;
    this.teamId = json?.teamId;
  }

  getEconomyRate() {
    let runsConceded = this.bowlingRuns + this.bowlingExtraRuns;
    let ballsBowled = this.ballsBowled;

    if (ballsBowled === 0 || !ballsBowled) {
      return 0; // Prevent division by zero error
    }
    const divisor = Math.floor(ballsBowled / 6) + (ballsBowled % 6) / 6;

    return parseFloat(runsConceded / divisor).toFixed(2); // Return economy rate rounded to 2 decimal places
  }

  getActualOvers() {
    return isNaN(Math.floor(this.ballsBowled / 6))
      ? "0"
      : Math.floor(this.ballsBowled / 6) + "." + (this.ballsBowled % 6);
  }

  getTotalBowlingRuns() {
    return this.bowlingRuns + this.bowlingExtraRuns;
  }
}

export class BowlingExtras4 {
  constructor(json) {
    this.byeruns = json?.byeruns;
    this.legbyes = json?.legbyes;
    this.noball = json?.noball;
    this.wide = json?.wide;
  }
}

export class ScoreBoard {
  constructor(json) {
    this.matchId = json?.matchId;
    this.teamA = new TeamA(json?.teamA);
    this.teamB = new TeamB(json?.teamB);
    this.superOverScoreboards = json?.superOverScoreboards?.map(
      (item) => new SuperOverScoreboard(item)
    );
  }
}

export class SuperOverScoreboard {
  constructor(json) {
    this.matchId = json?.matchId;
    this.teamA = json?.teamA;
    this.teamB = json?.teamB;
  }
}

export class TeamA {
  constructor(json) {
    this.teamId = json?.teamId;
    this.teamName = json?.teamName;
    this.teamLogo = json?.teamLogo;
    this.teamScoreboard = new TeamScoreboard(json?.teamScoreboard);
    this.playerScores = json?.playerScores.map((item) => new PlayerScore(item));
  }

  sortBatsmen() {
    const activeBatsmen = this.playerScores.filter(
      (item) =>
        (item._id !== undefined && item.ballsPlayed > 0) || item.isOnPitch
    );
    const inactiveBatsmen = this.playerScores.filter(
      (item) =>
        !((item._id !== undefined && item.ballsPlayed > 0) || item.isOnPitch)
    );

    activeBatsmen.sort((a, b) => a.battingOrder - b.battingOrder);

    return {
      activeBatsmen,
      inactiveBatsmen,
    };
  }

  sortBowlers() {
    const activeBowlers = this.playerScores.filter(
      (item) =>
        (item._id !== undefined && item.ballsBowled > 0) || item.isOnPitchBowl
    );

    const inactiveBowlers = this.playerScores.filter(
      (item) =>
        !(item._id !== undefined && item.ballsBowled > 0) || item.isOnPitchBowl
    );

    activeBowlers.sort((a, b) => a.bowlingOrder - b.bowlingOrder);

    return {
      activeBowlers,
      inactiveBowlers,
    };
  }
}

export class BowlingExtras5 {
  constructor(json) {
    this.byeruns = json?.byeruns;
    this.legbyes = json?.legbyes;
    this.noball = json?.noball;
    this.wide = json?.wide;
  }
}

export class PlayerScore {
  constructor(json) {
    this.playerId = json?.playerId;
    this.playerName = json?.playerName;
    this._id = json?._id;
    this.matchId = json?.matchId;
    this.fielderIds = json?.fielderIds;
    this.ballsBowled = json?.ballsBowled;
    this.ballsPlayed = json?.ballsPlayed;
    this.battingExtraRuns = json?.battingExtraRuns;
    this.battingExtraRunsMap = json?.battingExtraRunsMap;
    this.battingRuns = json?.battingRuns;
    this.bowlingExtraRuns = json?.bowlingExtraRuns;
    this.bowlingExtras = json?.bowlingExtras;
    this.bowlingRuns = json?.bowlingRuns;
    this.createdAt = json?.createdAt;
    this.noOf4s = json?.noOf4s;
    this.noOf6s = json?.noOf6s;
    this.noOfOvers = json?.noOfOvers;
    this.noOfWickets = json?.noOfWickets;
    this.updatedAt = json?.updatedAt;
    this.isStriker = json?.isStriker;
    this.isOnPitch = json?.isOnPitch;
    this.maidenOvers = json?.maidenOvers;
    this.wicketBy = json?.wicketBy;
    this.wicketTypeId = json?.wicketTypeId;
    this.is_captain = json?.is_captain;
    this.is_wicketkeeper = json?.is_wicketkeeper;
    this.battingOrder = json?.battingOrder;
    this.bowlingOrder = json?.bowlingOrder;
    this.isOnPitchBowl = json?.isOnPitchBowl;
  }

  getSr() {
    const runs = parseInt(this.battingRuns);
    const balls = parseInt(this.ballsPlayed);

    if (isNaN(runs) || isNaN(balls) || balls === 0) {
      return 0;
    }

    return (runs / balls) * 100;
  }

  getEconomyRate() {
    let runsConceded = this.bowlingRuns + this.bowlingExtraRuns;
    let ballsBowled = this.ballsBowled;

    if (ballsBowled === 0 || !ballsBowled) {
      return 0; // Prevent division by zero error
    }
    const divisor = Math.floor(ballsBowled / 6) + (ballsBowled % 6) / 6;

    return parseFloat(runsConceded / divisor).toFixed(2); // Return economy rate rounded to 2 decimal places
  }

  getActualOvers() {
    return isNaN(Math.floor(this.ballsBowled / 6))
      ? "0"
      : Math.floor(this.ballsBowled / 6) + "." + (this.ballsBowled % 6);
  }

  getWicketStr(wicketTypes, oppPlayers) {
    debugger;
    const wicketType = wicketTypes.find(
      (item) => item._id === this.wicketTypeId
    )?.name;
    const bowlerName = oppPlayers?.find(
      (item) => item.playerId === this.wicketBy
    )?.playerName;
    const fielderName = oppPlayers?.find(
      (item) => item.playerId === this.fielderIds
    )?.playerName;

    switch (wicketType) {
      case "Absent Hurt":
        return "absent hurt";
      case "Bowled":
        return `b ${bowlerName}`;
      case "Caught":
        return this.wicketBy === this.fielderIds
          ? `c and b ${bowlerName}`
          : `c ${fielderName} b ${bowlerName}`;
      case "Caught & Bowled":
        return `c and b ${bowlerName}`;
      case "Caught Behind":
        return `c ${fielderName} b ${bowlerName}`;
      case "Hit Wicket":
        return `hit wicket`;
      case "Hit the Ball Twice":
        return "hit the ball twice";
      case "LBW":
        return `lbw ${bowlerName}`;
      case "Obstr The Field":
        return "obstructing field";
      case "Retired":
        return "retired";
      case "Retired Hurt":
        return "retired hurt";
      case "Retired Out":
        return "retired out";
      case "Run Out":
        return `run out (${fielderName})`;
      case "Run Out (Mankaded)":
        return `run out (${bowlerName})`;
      case "Stumped":
        return `st ${fielderName} b ${bowlerName}`;
      case "Timed Out":
        return "timed out";

      default:
        return "not out";
    }
  }

  getTotalBowlingRuns() {
    return this.bowlingRuns + this.bowlingExtraRuns;
  }
}

export class BowlingExtras6 {
  constructor(json) {
    this.byeruns = json?.byeruns;
    this.legbyes = json?.legbyes;
    this.noball = json?.noball;
    this.wide = json?.wide;
  }
}

export class TeamB {
  constructor(json) {
    this.teamId = json?.teamId;
    this.teamName = json?.teamName;
    this.teamLogo = json?.teamLogo;
    this.teamScoreboard = new TeamScoreboard(json?.teamScoreboard);
    this.playerScores = json?.playerScores.map((item) => new PlayerScore(item));
  }

  sortBatsmen() {
    const activeBatsmen = this.playerScores.filter(
      (item) =>
        (item._id !== undefined && item.ballsPlayed > 0) || item.isOnPitch
    );
    const inactiveBatsmen = this.playerScores.filter(
      (item) =>
        !((item._id !== undefined && item.ballsPlayed > 0) || item.isOnPitch)
    );

    activeBatsmen.sort((a, b) => a.battingOrder - b.battingOrder);

    return {
      activeBatsmen,
      inactiveBatsmen,
    };
  }

  sortBowlers() {
    const activeBowlers = this.playerScores.filter(
      (item) =>
        (item._id !== undefined && item.ballsBowled > 0) || item.isOnPitchBowl
    );

    const inactiveBowlers = this.playerScores.filter(
      (item) =>
        !(item._id !== undefined && item.ballsBowled > 0) || item.isOnPitchBowl
    );

    activeBowlers.sort((a, b) => a.bowlingOrder - b.bowlingOrder);

    return {
      activeBowlers,
      inactiveBowlers,
    };
  }
}

export class BowlingExtras7 {
  constructor(json) {
    this.byeruns = json?.byeruns;
    this.legbyes = json?.legbyes;
    this.noball = json?.noball;
    this.wide = json?.wide;
  }
}

export class BowlingExtras8 {
  constructor(json) {
    this.byeruns = json?.byeruns;
    this.legbyes = json?.legbyes;
    this.noball = json?.noball;
    this.wide = json?.wide;
  }
}
